import { GrouperPlugin } from '@grouper/modules/core/plugins'
import Impersonate from '@grouper_premium/components/sidebar/Impersonate'
import HighestLicenseTypeBadge from '@grouper_premium/components/sidebar/HighestLicenseTypeBadge'
import PremiumViewOptions from '@grouper_premium/components/views/PremiumViewOptions'
import PublicViewExportMenuItem from '@grouper_premium/components/views/PublicViewExportMenuItem'

export class PremiumPlugin extends GrouperPlugin {
  static getType() {
    return 'premium'
  }

  getImpersonateComponent() {
    return Impersonate
  }

  getHighestLicenseTypeBadge() {
    return HighestLicenseTypeBadge
  }

  getAdditionalShareLinkOptions() {
    return [PremiumViewOptions]
  }

  getAdditionalPublicViewMenuItems(view) {
    return view.allow_public_export ? [PublicViewExportMenuItem] : []
  }

  hasFeature(feature, forSpecificWorkspace) {
    return this.app.$licenseHandler.hasFeature(feature, forSpecificWorkspace)
  }

  /**
   * A hook to provide different action buttons to the premium features modal.
   */
  getPremiumModalButtonsComponent() {
    return null
  }
}
